var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSlashCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#slash-circle_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M17.533 10A7.533 7.533 0 0 0 5.269 4.137L15.861 14.73A7.5 7.5 0 0 0 17.533 10M2.466 10a7.533 7.533 0 0 0 12.264 5.86L4.137 5.269A7.5 7.5 0 0 0 2.467 10m16.668 0a9.134 9.134 0 1 1-18.27-.001 9.134 9.134 0 0 1 18.269 0"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "slash-circle_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h20v20H0z"
})))));
SvgSlashCircle.displayName = "SvgSlashCircle";
export { SvgSlashCircle as ReactComponent };
export default SvgSlashCircle;